<template>
    <div>
        <div class="mx-2 sizing-container">
            <img :src="sizingImg" alt="" class="f1 sizing-placeholder">
            <div class="sizing-img" :style="{backgroundImage: `url(${imageUrl})`}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'GalleryCard',

        props: {
            imageUrl: {
                type: String,
                required: true
            }
        },

        computed: {
            base() {
                return window.imgUrl;
            },
            sizingImg() {
                return this.base + '/svg/44-19-sizing.svg';
            },
        }
    }
</script>
